import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, BookOpen, ShieldCheck, Calendar, Sparkles, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const RESOURCES = [
  { icon: ShieldCheck, title: "Credit Restoration", desc: "Your dispute strategy & progress updates will appear here." },
  { icon: BookOpen, title: "Wealth Library", desc: "Guides & financial literacy resources — coming to your account." },
  { icon: Calendar, title: "Consultations", desc: "Book and manage your strategy sessions." },
  { icon: Sparkles, title: "Exclusive Drops", desc: "Member-only masterclasses & offers." },
];

export default function MemberDashboard() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const doLogout = async () => { await logout(); nav("/"); };

  return (
    <div className="min-h-screen bg-[#050505] px-6 py-10">
      <div className="mx-auto max-w-5xl">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <Link to="/" className="font-display text-2xl font-bold tracking-[0.15em] text-gold">BGM</Link>
          <button onClick={doLogout} data-testid="member-logout"
            className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 font-body text-sm text-[#c9c9c9] hover:border-[#d4af37]/50 hover:text-gold">
            <LogOut className="h-4 w-4" /> Log out
          </button>
        </div>

        <div className="glass-solid gold-border-glow mt-8 overflow-hidden rounded-3xl p-8 sm:p-10" data-testid="member-dashboard">
          <div className="spotlight pointer-events-none absolute inset-0" />
          <span className="overline">Members lounge</span>
          <h1 className="mt-3 font-display text-3xl font-light tracking-tighter-x text-[#f5f5f5] sm:text-4xl">
            Welcome, <span className="gold-text-gradient">{user?.name || "Member"}</span>
          </h1>
          <p className="mt-3 max-w-xl font-body text-[#a3a3a3]">
            You're officially part of the BGM movement. This is your private space to Build, Grow and Maintain.
            Your tools and resources will unlock here.
          </p>
          <div className="mt-6 flex flex-wrap gap-3 font-body text-sm text-[#c9c9c9]">
            <span className="glass rounded-full px-4 py-2">Email: <span className="text-gold">{user?.email}</span></span>
            <span className="glass rounded-full px-4 py-2">Membership: <span className="text-gold capitalize">{user?.role}</span></span>
          </div>
        </div>

        <div className="mt-8 grid gap-5 sm:grid-cols-2">
          {RESOURCES.map((r, i) => (
            <div key={r.title} className="glass rounded-2xl p-7" data-testid={`member-resource-${i}`}>
              <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl border border-[#d4af37]/30 bg-[#d4af37]/10 text-gold"><r.icon className="h-6 w-6" /></span>
              <h3 className="font-display text-lg text-[#f5f5f5]">{r.title}</h3>
              <p className="mt-2 font-body text-sm text-[#a3a3a3]">{r.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 font-body text-xs text-[#666]">Coming soon <ArrowRight className="h-3 w-3" /></span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
